namespace Solovis.Reports.ReportHelpers.AggregateExposureOverTime {

    export class AggregateExposureOverTimeReportGenerator_v2 {

        public static generateReportDefinition() {

            let dataSourceForExposure = {
                name: "exposure",
                path: "/Solovis/Exposure/AggregateExposureOverTime_v2",

                parameterMap: function (parameters, more) {
                    let params: any = {};

                    params.componentSelectionSet = parameters.assetSelectionSet;

                    params.exposureRef = {
                        exposureType: parameters.exposureType
                    };

                    if (parameters.profile) {
                        params.exposureRef.profileId = parameters.profile.id;
                    }

                    if (parameters.tagSet) {
                        params.exposureRef.tagSetIds = parameters.tagSet.map(x => x.tagSetId);
                    }

                    if (parameters.asOfDate) {
                        params.dayId = parameters.asOfDate;
                    }
                    else {
                        params.dayId = InvData.DayId.today();
                    }

                    params.periodLength = parameters.periodLength;
                    params.periodsBack = parameters.periodsBack;

                    if (parameters.targetCurrency) {
                        params.targetCurrencyId = parameters.targetCurrency.id;
                    }

                    params.useBookedValues = parameters.useBookedValues;

                    params.includeTagSet = true;

                    return params;
                },

                postProcess: function (loadedDataSet, more) {
                    var lineItems = [];

                    var modelEnv = new InvData.ModelEnvironment();
                    loadedDataSet.tagSets.forEach((loadedTagSet) => {
                        var tagSet = new InvData.Models.TagSet(loadedTagSet);
                        modelEnv.tagSets.add(tagSet);
                    });

                    var overallByDay = loadedDataSet.overallByDay;

                    var runIdToGroupMap = {};

                    var maxDepth = 0;
                    $(loadedDataSet.groups).each(function (i, group: any) {
                        maxDepth = Math.max(group.depth, maxDepth);
                    });

                    $(loadedDataSet.groups).each(function (i, group: any) {
                        runIdToGroupMap[group.runId] = group;

                        // Collect level labels.
                        var levelLabels = {};
                        var currentGroup = group;
                        while (currentGroup) {
                            levelLabels["levelLabel_" + currentGroup.depth] = currentGroup.label;
                            currentGroup = runIdToGroupMap[currentGroup.parentRunId];
                        }
                        for (let levelCo = group.depth + 1; levelCo <= maxDepth; levelCo++) {
                            levelLabels["levelLabel_" + levelCo] = group.label;
                        }

                        $(group.byDay).each(function (j, dayEntry: any) {
                            var lineItem: any = {
                                runId: group.runId,
                                parentRunId: group.parentRunId,
                                label: group.label,
                                fullLabelPath: group.fullLabelPath,
                                dayId: dayEntry.dayId,
                                isLeaf: group.isLeaf,
                                tags: group.tags,
                                depth: group.depth,
                                levelLabels: levelLabels
                            };

                            lineItem.fullGroupNodeId = group.runId + "-" + dayEntry.dayId;
                            if (Solovis.isNotNull(group.parentRunId)) {
                                lineItem.fullParentGroupNodeId = group.parentRunId + "-" + dayEntry.dayId;
                            }

                            lineItem.long = dayEntry.long;
                            lineItem.short = dayEntry.short;
                            lineItem.net = dayEntry.long + dayEntry.short;
                            lineItem.gross = dayEntry.long - dayEntry.short;

                            var overall = overallByDay[j];
                            if (overall.overallValue) {
                                lineItem.longPercentage = lineItem.long / overall.overallValue;
                                lineItem.shortPercentage = lineItem.short / overall.overallValue;
                                lineItem.netPercentage = lineItem.net / overall.overallValue;
                                lineItem.grossPercentage = lineItem.gross / overall.overallValue;
                            }

                            lineItems.push(lineItem);
                        });
                    });

                    var dataSet = {
                        lineItems: lineItems,
                        originalDataSet: loadedDataSet,
                        modelEnv: modelEnv,
                        maxDepth: maxDepth
                    };

                    return dataSet;
                }
            };

            var createTagIdGetterForDataContext = function (tagSetIndex) {
                return function (dataContext) {
                    if (!dataContext.tags || tagSetIndex >= dataContext.tags.length)
                        return null;

                    if (dataContext.tags) {
                        if (dataContext.tags[tagSetIndex]) {
                            var tagId = dataContext.tags[tagSetIndex].tagId;
                            return tagId;
                        }
                    }
                };
            };

            var report = {

                parameters: [
                    {
                        name: "assetSelectionSet", label: "Asset Selection Set", parameterType: "assetSelectionSet",
                        validation: { required: true }
                    },

                    { name: "asOfDate", label: "As Of Date", parameterType: "dateIndex" },

                    {
                        name: "periodLength",
                        label: "Period Length",
                        parameterType: "choice",
                        initialValue: "Month",
                        settings: {
                            options: [
                                { label: "Day", value: "Day" },
                                { label: "Month", value: "Month" },
                                { label: "Quarter", value: "Quarter" },
                                { label: "Year", value: "Year" },
                                { label: "Fiscal Year", value: "FiscalYear" }
                            ]
                        }
                    },

                    { name: "periodsBack", label: "Periods Back", parameterType: "integer" },

                    {
                        name: "profile", label: "Profile", parameterType: "exposureProfile",
                        validation: { required: true }
                    },

                    {
                        name: "tagSet", list: true, label: "Tag Set", parameterType: "tagSet",
                        settings: { dependsOn: { exposureProfile: "profile" } },
                        validation: {
                            required: true,
                        }
                    },

                    {
                        name: "exposureType",
                        label: "Exposure Type",
                        parameterType: "choice",
                        initialValue: "MarketValue",
                        settings: {
                            options: [
                                { label: "Market Value", value: "MarketValue" },
                                { label: "Commitment Amount", value: "CommitmentAmount" }
                            ]
                        }
                    },

                    { name: "targetCurrency", label: "Target Currency", parameterType: "currency" },

                    { name: "useBookedValues", label: "Use Booked Values", parameterType: "bool" }
                ],

                root: {
                    elementName: "Root",

                    layout: "Vertical",

                    children: [
                        {
                            partControl: "Solovis.Reports.Parts.Tables.DataTableControl",
                            elementName: "AggregateExposureTable",

                            settings: {
                                columns: function () {
                                    var exposure = this.dataSets.exposure;

                                    var columns: any[] = [
                                        { id: "fullGroupNodeId", field: "fullGroupNodeId", label: "Group Id", dataType: "integer", hiddenByDefault: true },
                                        { id: "fullParentGroupNodeId", field: "fullParentGroupNodeId", label: "Parent Group Id", dataType: "integer", hiddenByDefault: true },

                                        { id: "label", field: "label", label: "Group", dataType: "string" },
                                        { id: "fullLabelPath", field: "fullLabelPath", label: "Full Label Path", dataType: "string", hiddenByDefault: true },
                                        { id: "dayId", field: "dayId", label: "Date", dataType: "dayId" },

                                        { id: "longPercentage", field: "longPercentage", label: "Long", superHeaders: ["%"], dataType: "percentage" },
                                        { id: "shortPercentage", field: "shortPercentage", label: "Short", superHeaders: ["%"], dataType: "percentage" },
                                        { id: "netPercentage", field: "netPercentage", label: "Net", superHeaders: ["%"], dataType: "percentage", hiddenByDefault: true },
                                        { id: "grossPercentage", field: "grossPercentage", label: "Gross", superHeaders: ["%"], dataType: "percentage", hiddenByDefault: true },

                                        { id: "long", field: "long", label: "Long", superHeaders: ["Amount"], dataType: "currency" },
                                        { id: "short", field: "short", label: "Short", superHeaders: ["Amount"], dataType: "currency" },
                                        { id: "net", field: "net", label: "Net", superHeaders: ["Amount"], dataType: "currency", hiddenByDefault: true },
                                        { id: "gross", field: "gross", label: "Gross", superHeaders: ["Amount"], dataType: "currency", hiddenByDefault: true },

                                        { id: "isLeaf", field: "isLeaf", label: "Is Leaf", dataType: "bool", hiddenByDefault: true },
                                        { id: "depth", field: "depth", label: "Depth", dataType: "integer", hiddenByDefault: true },
                                    ];

                                    exposure.modelEnv.tagSets.itemList.forEach((tagSet, i) => {
                                        columns.push({
                                            id: "tagSet" + i,
                                            field: createTagIdGetterForDataContext(i),
                                            label: tagSet.label,
                                            dataType: "tagId",
                                            tagSetId: tagSet.id,
                                            formatHint: { standardLinks: true },
                                            hiddenByDefault: true
                                        });
                                    });

                                    for (var i = 0; i <= exposure.maxDepth; i++) {
                                        columns.push({
                                            id: ("levelLabel_" + i), field: ("levelLabels.levelLabel_" + i), label: "Level " + i, dataType: "string", hiddenByDefault: true
                                        });
                                    }

                                    return columns;
                                },

                                groupBy: ["all"],

                                groups: function () {
                                    var groups = [];

                                    groups.push({
                                        id: "all",
                                        label: "All",
                                        dataRowsForGroups: true,
                                        field: "fullParentGroupNodeId",
                                        groupValueField: "fullGroupNodeId",
                                        htmlFormatter: function (value, valueContext) {
                                            var span = $("<span>");
                                            var backingRow = valueContext.row._backingRow;
                                            if (backingRow) {
                                                var assetLabel = backingRow.label;
                                                if (!backingRow.fullParentGroupNodeId) {
                                                    var dateStr = InvData.DayId.format(backingRow.dayId);
                                                    span.text(assetLabel + " (" + dateStr + ")");
                                                }
                                                else {
                                                    span.text(assetLabel);
                                                }
                                            }

                                            return span;
                                        }
                                    });

                                    return groups;
                                },

                                cellContextMenuItems: function (cellContext) {
                                    let row = cellContext.row;
                                    if (row._backingRow) {
                                        row = row._backingRow;
                                    }

                                    let dayId = row.dayId;
                                    let parameters = cellContext.reportControl.getSerializedParameterValues();
                                    let exposure = cellContext.reportControl.getReportPartControl("AggregateExposureTable").dataSets.exposure;

                                    let rollUpLink = AggregateExposureOverTimeReportGenerator_v2.createLinkToRollUpReport(exposure.modelEnv, parameters, dayId);

                                    let links = [];

                                    links.push(rollUpLink);

                                    let reportCodeForAggregateExposureOverTimeChart = "E5213BF3-EE45-4BFE-9044-DCC7566EAD6A";
                                    let aggregateExposureOverTimeChartParams = AggregateExposureOverTimeReportGenerator_v2.copyCoreAggregateExposureParameters(parameters);
                                    let aggregateExposureOverTimeChartUrl = Solovis.Reports.ReportLinker.getReportLink({
                                        reportCode: reportCodeForAggregateExposureOverTimeChart,
                                        parameters: aggregateExposureOverTimeChartParams,
                                        autoRun: true
                                    });
                                    let aggregateExposureOverTimeChartLabel = "Aggregate Exposure Over Time Chart"

                                    links.push({
                                        label: aggregateExposureOverTimeChartLabel,
                                        href: aggregateExposureOverTimeChartUrl
                                    });

                                    return links;
                                },

                                aggregateRow: {
                                    display: "inline",
                                    groupHeaderColspan: 1
                                },

                                rowData: "dataSets.exposure.lineItems",

                                modelEnvironment: { path: "exposure.modelEnv" }
                            },

                            dataSources: [
                                { name: "exposure", ref: { elementName: "Root", dataSourceName: "exposure" } }
                            ]
                        }
                    ],

                    dataSources: [
                        dataSourceForExposure
                    ]
                }
            };

            return report;
        };

        public static copyCoreAggregateExposureParameters(parameters) {
            let params = {
                assetSelectionSet: parameters.assetSelectionSet,
                asOfDate: parameters.asOfDate,
                periodLength: parameters.periodLength,
                periodsBack: parameters.periodsBack,
                profile: parameters.profile,
                tagSet: parameters.tagSet,
                exposureType: parameters.exposureType,
                targetCurrency: parameters.targetCurrency,
                useBookedValues: parameters.useBookedValues,
            };

            return params;
        }

        public static createLinkToRollUpReport(modelEnv, parameters, dayId) {
            let exposureRollUpParams = {
                assetSelectionSet: parameters.assetSelectionSet,
                asOfDate: dayId ? dayId : parameters.asOfDate,
                profile: parameters.profile,
                targetCurrency: parameters.targetCurrency,
                useBookedValues: parameters.useBookedValues,
            };

            // Exposure Roll-up Line Items
            let reportCodeForExposureRollUpLineItems = "FEC0D928-9E3D-4FE5-804C-0ECEEF9D8E35";
            let groupByList = [{ "id": "all" }];
            if (modelEnv) {
                modelEnv.tagSets.itemList.forEach((tagSet) => {
                    groupByList.push({ "id": "tagSet" + tagSet.id });
                });
            }

            let exposureRollUpUrl = Solovis.Reports.ReportLinker.getReportLink({
                reportCode: reportCodeForExposureRollUpLineItems,
                parameters: exposureRollUpParams,
                persistedSettings: {
                    ExposureTable: { "groupBy": groupByList },
                },
                autoRun: true
            });
            let exposureRollUpLabel = "Exposure Roll-up Line Items"
            if (dayId) {
                exposureRollUpLabel += " - " + InvData.DayId.format(dayId);
            }

            return {
                label: exposureRollUpLabel,
                href: exposureRollUpUrl
            };
        }
    }

}